import { render, staticRenderFns } from "./BottomNotice.vue?vue&type=template&id=988833d6&scoped=true"
import script from "./BottomNotice.vue?vue&type=script&lang=ts"
export * from "./BottomNotice.vue?vue&type=script&lang=ts"
import style0 from "./BottomNotice.vue?vue&type=style&index=0&id=988833d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988833d6",
  null
  
)

export default component.exports